import React from 'react'
import { SidebarComponent } from "@syncfusion/ej2-react-navigations";
import _ from "lodash";
import ToggleImg from "../../../assets/infofleet/live.png";
import { Button } from "@mui/material";
import { Card, CardBody, OverlayTrigger, Tooltip } from "react-bootstrap";


function CustomSideBarComponent(props) {
  const { filteredData,
    sidebarselectedAsset,
    singleassetdata,
    sensorview,
  } = props
  const [height, setHeight] = React.useState(window.innerHeight);
  const windowheight = height - 50;
  const sidebarview = {
    height: windowheight - 65 + "px",
    width: "100%",
    overflowX: "hidden",
    visibility: "visible",
    // padding: "6px",
  };
  const [toggleicon, ToggleIcon] = React.useState(2);
  var sidebarObj = "Sidebar";
  // Sidebar Option
  const toggleClick = (e) => {
    sidebarObj.toggle();
  };
  const onCreate = () => {
    sidebarObj.element.style.visibility = "visible";
  };
  // Sidebar Option


  const open = () => {
    ToggleIcon(2);
  };
  const close = () => {
    ToggleIcon(1);
  };
  // Sidebar Option
  return (
    <div className="control-section">
      <div id="wrapper">
        <SidebarComponent
          id="default-sidebar"
          ref={(Sidebar) => (sidebarObj = Sidebar)}
          close={close}
          open={open}
          created={onCreate}
          type="Push"
          position="Left"
          style={sidebarview}
        >
          <div role="presentation">
            <>
              <Card>
                {
                  filteredData !== "" &&
                    filteredData !== undefined &&
                    filteredData.length !== 0 ? (
                    <>
                      {filteredData.map((lpdata, index) => (
                        <div style={{ "padding": "1px" }}
                          key={lpdata.id}
                          className="col-ls-12 col-md-12"
                          onClick={() => sidebarselectedAsset(lpdata)}
                        >
                          <CardBody
                            className={`${_.toNumber(singleassetdata.vehicleId) === lpdata.vehicleId
                              ? lpdata.vmode === "Moving"
                                ? "selectedvehiclepanel_moving"
                                : lpdata.vmode === "Parked"
                                  ? "selectedvehiclepanel_parked"
                                  : lpdata.vmode === "Stopped"
                                    ? "selectedvehiclepanel_stopped"
                                    : lpdata.vmode === "Idling Engine ON"
                                      ? "selectedvehiclepanel_engineon"
                                      : lpdata.vmode === "No Signal"
                                        ? "selectedvehiclepanel_nosignal"
                                        : ""
                              : ""
                              } liveview_section`}
                          >
                            <div className="row align-items-center">
                              {/* Vehicle Mode aligned right */}
                              <div className="col-12 d-flex justify-content-end">
                                <span
                                  className={`${lpdata.vmode === "Moving"
                                    ? "liveview_label_moving"
                                    : lpdata.vmode === "Parked"
                                      ? "liveview_label_parked"
                                      : lpdata.vmode === "Stopped"
                                        ? "liveview_label_stopped"
                                        : lpdata.vmode === "Idling Engine ON"
                                          ? "liveview_label_engineon"
                                          : lpdata.vmode === "No Signal"
                                            ? "liveview_label_nosignal"
                                            : ""
                                    } text-center p_0 br_2 mh_20`}
                                >
                                  {lpdata.vmode === "Idling Engine ON" ? "Idling Eng ON" : lpdata.vmode}
                                </span>
                              </div>

                              {/* Plate Number in separate row */}
                              <div className="col-12 text-start mt-1">
                                <span>{lpdata.plateNo} ({lpdata.regEmirate})</span>
                              </div>

                              {/* Asset Info */}
                              <div className="col-12">
                                <span>{lpdata.assetName} - {lpdata.assetMake} / {lpdata.assetModel}</span>
                              </div>

                              {/* Driver / Speed / Date */}
                              <div className="col-12 d-flex justify-content-between lv_dd">
                                <span>{lpdata.driverName}</span>
                                <span>{lpdata.speed} Km/h</span>
                                <span>{lpdata.dateTime}</span>
                              </div>

                              {/* Sensor values if visible */}
                              {sensorview && (
                                <div className="col-12 d-flex justify-content-between">
                                  <span>Temp 1 - {lpdata.tSensor1 || "Nil"}</span>
                                  <span>Temp 2 - {lpdata.tSensor2 || "Nil"}</span>
                                </div>
                              )}
                            </div>
                          </CardBody>

                        </div>
                      ))}
                    </>
                  ) : (
                    ""
                  )}
              </Card>
            </>
          </div>

        </SidebarComponent>
        <div>
          <div className="center-align">
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Please click to open Live View</Tooltip>}
            >
              <Button
                onClick={toggleClick}
                className={`${toggleicon === 1 ? "ms_toggle_icon right_300" : "ms_toggle_icon right_0"
                  } ms_toggle_icon`}
              >
                <img alt="Toggle icon" src={ToggleImg} />
              </Button>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </div>
  )
}
export default CustomSideBarComponent;